import { getAccessTokenJwtHeader } from '@/assets/src/amplify/helpers';
import { StripeCoupon, StripePlan } from './stripe_client';
import { getJson, deleteJson, postJson } from '@/assets/src/json_loader';
import { API_URL } from '@/assets/src/configs';

const listCouponEndpoint = `${API_URL}/private/coupons`;
const couponEndpoint = `${API_URL}/private/coupon`;

export interface Coupon {
  id: number;
  created_at: string;
  deleted_at: string;
  code: string;
  description: string;
  stripe_coupon: StripeCoupon;
  valid_plans: StripePlan;
}

export interface AddCouponInput {
  coupon_code: string;
  description: string;
  stripe_coupon_id: string;
  valid_plan_ids: string[];
}

export class CouponClient {
  public async listCoupons(): Promise<Coupon[]> {
    const headers = await getAccessTokenJwtHeader();
    const response: any = await getJson(listCouponEndpoint, headers);

    return response.coupons;
  }

  public async deleteCoupon(id: number): Promise<void> {
    const headers = await getAccessTokenJwtHeader();
    const endpoint = `${couponEndpoint}/${id}`;
    await deleteJson(endpoint, headers);
  }

  public async addCoupon(input: AddCouponInput): Promise<void> {
    const headers = await getAccessTokenJwtHeader();
    await postJson(couponEndpoint, input, headers);
  }
}
